import React, { ReactNode } from 'react';

interface FormProps {
  children: ReactNode | ReactNode[];
  onSubmit: (e: React.FormEvent) => void;
  className?: string;
}

export const Form = ({
  children,
  onSubmit,
  className,
  ...props
}: FormProps) => (
  <form
    className={className}
    noValidate
    onSubmit={(e) => {
      e.preventDefault();
      e.stopPropagation();
      onSubmit(e);
    }}
    {...props}
  >
    {children}
  </form>
);
